Mostrando&nbsp;<span class="text-primary"><span class="font-weight-bold">
        {{((page - 1) * perPage) + 1}}-{{((page - 1) * perPage) + count}}</span>&nbsp;de&nbsp;<span
        class="font-weight-bold">{{total}}</span>&nbsp;{{label}}</span>